import { ObuStateCommandRequest } from 'ctp-state';
import moment from 'moment';

// filtersDevice needs to be mapped to type Filter (from lib device registry)
// inputType is used to make the mapping easier since we need to work multiselects, arrays of different types...etc.
// multi_string and multi_number are used for any multiselects with checkboxes
const filtersDevice = [
  {
    id: 'countries',
    translateKey: 'country',
    initialOptions: [],
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: true,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'euro_values',
    translateKey: 'euro_value',
    initialOptions: [],
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: true,
    searchQuery: '',
    inputType: 'multi_number'
  },
  {
    id: 'plate_number',
    translateKey: 'plate_number',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'device_ids',
    translateKey: 'device_id',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'device_types',
    translateKey: 'device_type',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'last_seen_seconds',
    translateKey: 'last_seen_seconds',
    options: [
      moment.duration(10, 'minutes').asSeconds().toString(),
      moment.duration(1, 'hours').asSeconds().toString(),
      moment.duration(1, 'days').asSeconds().toString(),
      moment.duration(7, 'days').asSeconds().toString(),
      moment.duration(1, 'months').asSeconds().toString(),
      moment.duration(3, 'months').asSeconds().toString()
    ],
    values: '',
    isOpen: true,
    displaySearchBar: false,
    inputType: 'number'
  },
  {
    id: 'vehicle_class',
    translateKey: 'vehicle_class',
    options: ['1', '2', '3', '4', '5', '6', '7'],
    values: [],
    isOpen: true,
    displaySearchBar: false,
    inputType: 'multi_number'
  },
  {
    id: 'number_axles_tractor',
    translateKey: 'tractor_axles',
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: false,
    inputType: 'multi_number'
  },
  {
    id: 'number_axles_trailer',
    translateKey: 'trailer_axles',
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: false,
    inputType: 'multi_number'
  },
  {
    id: 'max_laden_weight',
    translateKey: 'max_laden_weight',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    searchQuery: '',
    displaySearchBar: false,
    inputType: 'number[]'
  },
  {
    id: 'train_maximum_weight',
    translateKey: 'max_train_weight',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    searchQuery: '',
    displaySearchBar: false,
    inputType: 'number[]'
  },
  {
    id: 'weight_unladen',
    translateKey: 'unladen_weight',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    searchQuery: '',
    displaySearchBar: false,
    inputType: 'number[]'
  },
  {
    id: 'device_status',
    translateKey: 'device_status',
    options: [
      ObuStateCommandRequest.TargetStateEnum.Active.toString(),
      ObuStateCommandRequest.TargetStateEnum.Ban.toString(),
      ObuStateCommandRequest.TargetStateEnum.Lock.toString(),
      ObuStateCommandRequest.TargetStateEnum.Transport.toString()
    ],
    values: [],
    isOpen: true,
    displaySearchBar: false,
    inputType: 'multi_string'
  },
  {
    id: 'customers_names',
    translateKey: 'customer_name',
    initialOptions: [],
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: true,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'tollzone_codes',
    translateKey: 'tollzone_codes',
    initialOptions: [],
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: true,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'tollzone_names',
    translateKey: 'tollzone_names',
    initialOptions: [],
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: true,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'variants',
    translateKey: 'variants',
    initialOptions: [],
    options: [],
    values: [],
    isOpen: true,
    displaySearchBar: true,
    searchQuery: '',
    inputType: 'multi_number'
  }
];

export default filtersDevice;
